import { render, staticRenderFns } from "./joinList.vue?vue&type=template&id=5d8f1214&scoped=true"
import script from "./joinList.vue?vue&type=script&lang=js"
export * from "./joinList.vue?vue&type=script&lang=js"
import style0 from "./joinList.vue?vue&type=style&index=0&id=5d8f1214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8f1214",
  null
  
)

export default component.exports